// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  --at-brand: var(--fc-brand, #5ea1d8);
  --at-text: #1f2328;
  --at-muted: #667085;
  --at-border: #e4e7ec;
  --at-card: #ffffff;
  --at-soft: #f6f8fa;
  --at-del-bg: #fdecec;
  --at-del-fg: #b42318;
  --at-ins-bg: #e8f7ee;
  --at-ins-fg: #067647;
  display: block;
  min-width: 0;
  max-width: 100%;
}

:host-context(.theme-dark-layout),
:host-context(body.theme-dark) {
  --at-text: #e6e8eb;
  --at-muted: #98a2b3;
  --at-border: #2f3542;
  --at-card: #1b1f27;
  --at-soft: #232834;
  --at-del-bg: rgba(240, 68, 56, 0.16);
  --at-del-fg: #fda29b;
  --at-ins-bg: rgba(18, 183, 106, 0.16);
  --at-ins-fg: #75e0a7;
}

.timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.timeline__item {
  display: grid;
  /* minmax(0, …) lets the card shrink instead of growing to its widest content */
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 12px;
  position: relative;
  padding-bottom: 16px;
}
.timeline__item::before {
  content: "";
  position: absolute;
  left: 19px;
  top: 40px;
  bottom: 0;
  width: 2px;
  background: var(--at-border);
}
.timeline__item:last-child::before {
  display: none;
}
.timeline__item[data-tone=success] .timeline__card {
  border-left-color: #12b76a;
}
.timeline__item[data-tone=danger] .timeline__card {
  border-left-color: #f04438;
}
.timeline__item[data-tone=info] .timeline__card {
  border-left-color: var(--at-brand);
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--at-brand);
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  z-index: 1;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.timeline__card {
  background: var(--at-card);
  border: 1px solid var(--at-border);
  border-left: 3px solid var(--at-border);
  border-radius: 12px;
  padding: 12px 14px;
  min-width: 0;
  color: var(--at-text);
}

.timeline__head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.timeline__who {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}
.timeline__who .actor {
  font-size: 14px;
  font-weight: 600;
}
.timeline__who .action {
  font-size: 14px;
  overflow-wrap: anywhere;
}
.timeline__who .version {
  font-size: 11px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 999px;
  background: var(--at-soft);
  color: var(--at-muted);
}

.timeline__time {
  font-size: 12px;
  color: var(--at-muted);
  white-space: nowrap;
}

.timeline__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.timeline__meta .email {
  font-size: 12px;
  color: var(--at-muted);
  word-break: break-all;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--at-soft);
  color: var(--at-muted);
}
.chip mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.timeline__target {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 6px 10px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  border: 1px dashed var(--at-border);
  border-radius: 8px;
  background: transparent;
  color: var(--at-text);
  text-align: left;
  cursor: pointer;
  font-size: 13px;
}
.timeline__target:disabled {
  cursor: default;
  opacity: 0.8;
}
.timeline__target:not(:disabled):hover {
  border-color: var(--at-brand);
}
.timeline__target mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--at-brand);
}
.timeline__target .kind {
  font-size: 11px;
  font-weight: 600;
  color: var(--at-muted);
  text-transform: uppercase;
}
.timeline__target mat-icon,
.timeline__target .kind {
  flex-shrink: 0;
}
.timeline__target .title {
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.transition {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
}
.transition mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: var(--at-muted);
}

.state {
  font-size: 12px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 999px;
  background: var(--at-soft);
  color: var(--at-text);
}
.state[data-state=InReview] {
  background: rgba(94, 161, 216, 0.16);
  color: var(--at-brand);
}
.state[data-state=Approved], .state[data-state=Published] {
  background: var(--at-ins-bg);
  color: var(--at-ins-fg);
}
.state[data-state=Rejected] {
  background: var(--at-del-bg);
  color: var(--at-del-fg);
}

.comment {
  margin: 10px 0 0;
  padding: 8px 12px;
  border-left: 3px solid var(--at-brand);
  background: var(--at-soft);
  border-radius: 0 8px 8px 0;
  font-size: 13px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.changes {
  width: 100%;
  margin-top: 10px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
  table-layout: fixed;
}
.changes th,
.changes td {
  padding: 6px 8px;
  vertical-align: top;
  text-align: left;
  border-bottom: 1px solid var(--at-border);
  word-break: break-word;
  overflow-wrap: anywhere;
  min-width: 0;
}
.changes thead th {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--at-muted);
}
.changes thead th:first-child {
  width: 30%;
}
.changes tbody th {
  font-weight: 600;
  color: var(--at-text);
}
.changes tbody tr:last-child th,
.changes tbody tr:last-child td {
  border-bottom: none;
}
.changes del,
.changes ins {
  text-decoration: none;
  display: inline;
  padding: 1px 4px;
  border-radius: 4px;
  line-height: 1.6;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}
.changes del {
  background: var(--at-del-bg);
  color: var(--at-del-fg);
  text-decoration: line-through;
}
.changes ins {
  background: var(--at-ins-bg);
  color: var(--at-ins-fg);
}
.changes .empty {
  color: var(--at-muted);
}

.details {
  display: grid;
  grid-template-columns: minmax(90px, 30%) 1fr;
  gap: 4px 12px;
  margin: 10px 0 0;
  font-size: 13px;
}
.details dt {
  font-weight: 600;
  color: var(--at-muted);
}
.details dd {
  margin: 0;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.more {
  margin-top: 6px;
  padding: 0;
  border: none;
  background: none;
  color: var(--at-brand);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.no-diff {
  margin: 8px 0 0;
  font-size: 12px;
  color: var(--at-muted);
}

@media (max-width: 600px) {
  .timeline__item {
    grid-template-columns: 32px 1fr;
    gap: 8px;
  }
  .timeline__item::before {
    left: 15px;
    top: 32px;
  }
  .avatar {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
  .changes thead {
    display: none;
  }
  .changes tr {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    border-bottom: 1px solid var(--at-border);
    padding: 6px 0;
  }
  .changes tbody th {
    grid-column: 1/-1;
    border-bottom: none;
    padding-bottom: 2px;
  }
  .changes td {
    border-bottom: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/activity-timeline/activity-timeline.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AAEF;;AACA;;EAEE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,oBAAA;EACA,qCAAA;EACA,oBAAA;AAEF;;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAEF;;AACA;EACE,aAAA;EACA,+EAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;AAEF;AAAE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,4BAAA;AAEJ;AACE;EACE,aAAA;AACJ;AAEE;EACE,0BAAA;AAAJ;AAEE;EACE,0BAAA;AAAJ;AAEE;EACE,kCAAA;AAAJ;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADJ;;AAKA;EACE,0BAAA;EACA,kCAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AAFF;AAIE;EACE,eAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;EACA,uBAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0BAAA;EACA,sBAAA;AAJJ;;AAQA;EACE,eAAA;EACA,sBAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AALF;AAOE;EACE,eAAA;EACA,sBAAA;EACA,qBAAA;AALJ;;AASA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0BAAA;EACA,sBAAA;AANF;AAQE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AANJ;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,mCAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAPF;AASE;EACE,eAAA;EACA,YAAA;AAPJ;AAUE;EACE,6BAAA;AARJ;AAWE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AATJ;AAYE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAVJ;AAaE;;EAEE,cAAA;AAXJ;AAcE;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAbF;AAeE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAbJ;;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,qBAAA;AAdF;AAgBE;EACE,oCAAA;EACA,sBAAA;AAdJ;AAgBE;EAEE,4BAAA;EACA,uBAAA;AAfJ;AAiBE;EACE,4BAAA;EACA,uBAAA;AAfJ;;AAmBA;EACE,gBAAA;EACA,iBAAA;EACA,sCAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAhBF;AAkBE;;EAEE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAjBJ;AAoBE;EACE,UAAA;AAlBJ;AAqBE;EACE,gBAAA;EACA,qBAAA;AAnBJ;AAsBE;;EAEE,mBAAA;AApBJ;AAuBE;;EAEE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mCAAA;AArBJ;AAwBE;EACE,4BAAA;EACA,uBAAA;EACA,6BAAA;AAtBJ;AAyBE;EACE,4BAAA;EACA,uBAAA;AAvBJ;AA0BE;EACE,sBAAA;AAxBJ;;AA4BA;EACE,aAAA;EACA,4CAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAzBF;AA2BE;EACE,gBAAA;EACA,sBAAA;AAzBJ;AA4BE;EACE,SAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;AA1BJ;;AA8BA;EACE,eAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,eAAA;EACA,sBAAA;AA3BF;;AA8BA;EACE;IACE,+BAAA;IACA,QAAA;EA3BF;EA6BE;IACE,UAAA;IACA,SAAA;EA3BJ;EA+BA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA7BF;EAiCE;IACE,aAAA;EA/BJ;EAkCE;IACE,aAAA;IACA,oDAAA;IACA,yCAAA;IACA,cAAA;EAhCJ;EAmCE;IACE,iBAAA;IACA,mBAAA;IACA,mBAAA;EAjCJ;EAoCE;IACE,mBAAA;EAlCJ;AACF","sourcesContent":[":host {\n  --at-brand: var(--fc-brand, #5ea1d8);\n  --at-text: #1f2328;\n  --at-muted: #667085;\n  --at-border: #e4e7ec;\n  --at-card: #ffffff;\n  --at-soft: #f6f8fa;\n  --at-del-bg: #fdecec;\n  --at-del-fg: #b42318;\n  --at-ins-bg: #e8f7ee;\n  --at-ins-fg: #067647;\n  display: block;\n  min-width: 0;\n  max-width: 100%;\n}\n\n:host-context(.theme-dark-layout),\n:host-context(body.theme-dark) {\n  --at-text: #e6e8eb;\n  --at-muted: #98a2b3;\n  --at-border: #2f3542;\n  --at-card: #1b1f27;\n  --at-soft: #232834;\n  --at-del-bg: rgba(240, 68, 56, 0.16);\n  --at-del-fg: #fda29b;\n  --at-ins-bg: rgba(18, 183, 106, 0.16);\n  --at-ins-fg: #75e0a7;\n}\n\n.timeline {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.timeline__item {\n  display: grid;\n  /* minmax(0, …) lets the card shrink instead of growing to its widest content */\n  grid-template-columns: 40px minmax(0, 1fr);\n  gap: 12px;\n  position: relative;\n  padding-bottom: 16px;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 19px;\n    top: 40px;\n    bottom: 0;\n    width: 2px;\n    background: var(--at-border);\n  }\n\n  &:last-child::before {\n    display: none;\n  }\n\n  &[data-tone=\"success\"] .timeline__card {\n    border-left-color: #12b76a;\n  }\n  &[data-tone=\"danger\"] .timeline__card {\n    border-left-color: #f04438;\n  }\n  &[data-tone=\"info\"] .timeline__card {\n    border-left-color: var(--at-brand);\n  }\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--at-brand);\n  color: #fff;\n  font-weight: 600;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.timeline__card {\n  background: var(--at-card);\n  border: 1px solid var(--at-border);\n  border-left: 3px solid var(--at-border);\n  border-radius: 12px;\n  padding: 12px 14px;\n  min-width: 0;\n  color: var(--at-text);\n}\n\n.timeline__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.timeline__who {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 6px;\n  min-width: 0;\n\n  .actor {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  .action {\n    font-size: 14px;\n    overflow-wrap: anywhere;\n  }\n\n  .version {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 1px 6px;\n    border-radius: 999px;\n    background: var(--at-soft);\n    color: var(--at-muted);\n  }\n}\n\n.timeline__time {\n  font-size: 12px;\n  color: var(--at-muted);\n  white-space: nowrap;\n}\n\n.timeline__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n\n  .email {\n    font-size: 12px;\n    color: var(--at-muted);\n    word-break: break-all;\n  }\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--at-soft);\n  color: var(--at-muted);\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.timeline__target {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  padding: 6px 10px;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: 1px dashed var(--at-border);\n  border-radius: 8px;\n  background: transparent;\n  color: var(--at-text);\n  text-align: left;\n  cursor: pointer;\n  font-size: 13px;\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.8;\n  }\n\n  &:not(:disabled):hover {\n    border-color: var(--at-brand);\n  }\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: var(--at-brand);\n  }\n\n  .kind {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--at-muted);\n    text-transform: uppercase;\n  }\n\n  mat-icon,\n  .kind {\n    flex-shrink: 0;\n  }\n\n  .title {\n    flex: 1 1 auto;\n    min-width: 0;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.transition {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    color: var(--at-muted);\n  }\n}\n\n.state {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 2px 10px;\n  border-radius: 999px;\n  background: var(--at-soft);\n  color: var(--at-text);\n\n  &[data-state=\"InReview\"] {\n    background: rgba(94, 161, 216, 0.16);\n    color: var(--at-brand);\n  }\n  &[data-state=\"Approved\"],\n  &[data-state=\"Published\"] {\n    background: var(--at-ins-bg);\n    color: var(--at-ins-fg);\n  }\n  &[data-state=\"Rejected\"] {\n    background: var(--at-del-bg);\n    color: var(--at-del-fg);\n  }\n}\n\n.comment {\n  margin: 10px 0 0;\n  padding: 8px 12px;\n  border-left: 3px solid var(--at-brand);\n  background: var(--at-soft);\n  border-radius: 0 8px 8px 0;\n  font-size: 13px;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.changes {\n  width: 100%;\n  margin-top: 10px;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;\n  table-layout: fixed;\n\n  th,\n  td {\n    padding: 6px 8px;\n    vertical-align: top;\n    text-align: left;\n    border-bottom: 1px solid var(--at-border);\n    word-break: break-word;\n    overflow-wrap: anywhere;\n    min-width: 0;\n  }\n\n  thead th {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: var(--at-muted);\n  }\n\n  thead th:first-child {\n    width: 30%;\n  }\n\n  tbody th {\n    font-weight: 600;\n    color: var(--at-text);\n  }\n\n  tbody tr:last-child th,\n  tbody tr:last-child td {\n    border-bottom: none;\n  }\n\n  del,\n  ins {\n    text-decoration: none;\n    display: inline;\n    padding: 1px 4px;\n    border-radius: 4px;\n    line-height: 1.6;\n    box-decoration-break: clone;\n    -webkit-box-decoration-break: clone;\n  }\n\n  del {\n    background: var(--at-del-bg);\n    color: var(--at-del-fg);\n    text-decoration: line-through;\n  }\n\n  ins {\n    background: var(--at-ins-bg);\n    color: var(--at-ins-fg);\n  }\n\n  .empty {\n    color: var(--at-muted);\n  }\n}\n\n.details {\n  display: grid;\n  grid-template-columns: minmax(90px, 30%) 1fr;\n  gap: 4px 12px;\n  margin: 10px 0 0;\n  font-size: 13px;\n\n  dt {\n    font-weight: 600;\n    color: var(--at-muted);\n  }\n\n  dd {\n    margin: 0;\n    min-width: 0;\n    word-break: break-word;\n    overflow-wrap: anywhere;\n  }\n}\n\n.more {\n  margin-top: 6px;\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--at-brand);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.no-diff {\n  margin: 8px 0 0;\n  font-size: 12px;\n  color: var(--at-muted);\n}\n\n@media (max-width: 600px) {\n  .timeline__item {\n    grid-template-columns: 32px 1fr;\n    gap: 8px;\n\n    &::before {\n      left: 15px;\n      top: 32px;\n    }\n  }\n\n  .avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n\n  .changes {\n    thead {\n      display: none;\n    }\n\n    tr {\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n      border-bottom: 1px solid var(--at-border);\n      padding: 6px 0;\n    }\n\n    tbody th {\n      grid-column: 1 / -1;\n      border-bottom: none;\n      padding-bottom: 2px;\n    }\n\n    td {\n      border-bottom: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
